import api from '@/api';

const { $student } = api;

export const { $examsTitle,$titulations } = $student;
 